import { render, staticRenderFns } from "./Recommendation.Compare.vue?vue&type=template&id=11a7d942&scoped=true&"
import script from "./Recommendation.Compare.vue?vue&type=script&lang=js&"
export * from "./Recommendation.Compare.vue?vue&type=script&lang=js&"
import style0 from "./Recommendation.Compare.vue?vue&type=style&index=0&id=11a7d942&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a7d942",
  null
  
)

export default component.exports